import { InputHTMLAttributes, LegacyRef } from 'react';
import { useTranslation } from 'react-i18next';

require('./IconTextField.css');

export type Props = InputHTMLAttributes<HTMLInputElement> & {
    id: string;
    icon: string;
    required?: boolean;
    label?: string;
    labelKey?: string;
    error?: string;
    setRef?: LegacyRef<any>;
};

export const IconTextField = ({ required, id, setRef, label, labelKey, icon, type, error, ...props }: Props) => {
    const { t } = useTranslation();

    return (
        <div className={ `ui left icon input ${required ? 'required' : ''} field text-field` } style={ { display: 'block' } }>
            { (label || labelKey) &&
                <label htmlFor={ id }>
                    { label || t(labelKey!) }
                </label>
            }
            <input
                id={ id }
                ref={ setRef }
                type={ type || "text" }
                { ...props }
            />
            <i className={ `${icon} icon` }/>
            { error &&
                <div className="error">
                    { error }
                </div>
            }
        </div>
    );
};

